<template>
    <div id="app">
        <Header/>
            <router-view :key="$route.fullPath"><Home/></router-view>
        <Footer/>
        <div id="wrapper" class="bg-wrapper"/>
    </div>
</template>

<script>
import Header from "../src/assets/components/Header.vue";
import Footer from "../src/assets/components/Footer.vue";
import Cms from "@/services/Cms";
export default {
    name:"home-page",
    components:{
        Header,
        Footer
    },
    beforeMount(){
        Cms.getContactInfo()
        .then(resp => this.$store.commit('storeContactInfo',  resp.data.data))
        .catch(error =>  console.error("Failed to get contact info.") );
    },
    mounted(){
        if(window.location.host == "www.onsite-safety.co.uk") this.renderGTag();
    },
    methods: {
        renderGTag(){
            const tagManager = document.createElement('script');
            const gTagScript = document.createElement('script');

            tagManager.src = "https://www.googletagmanager.com/gtag/js?id=UA-219872-3";
            gTagScript.text = `window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-219872-3');
                                gtag('config', 'AW-1063222004');`;
            
            document.body.appendChild(tagManager);
            document.body.appendChild(gTagScript);
        }
    }
};
</script>
<style lang="scss">
.bg-wrapper{
       position: absolute;
    background-color: rgba(0, 0, 0, 0.32);
    width: 100%;
    height: 100vh;
    display: none;
    top: 0;
    transition: background-color .5s;
}
</style>
